const getCart = async function () {
  const result = await fetch('/cart.json');

  if (result.status === 200) {
    return result.json();
  }
  throw new Error(
    `Failed to get request, Shopify returned ${result.status} ${result.statusText}`
  );
};

const updateCart = async function (updates) {
  const result = await fetch('/cart/update.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(updates),
  });

  if (result.status === 200) {
    return result.json();
  }

  throw new Error(
    `Failed to get request, Shopify returned ${result.status} ${result.statusText}`
  );
};

const setCustomerCartAttribute = () => {
  document.dispatchEvent(new Event('set customer cart attribute'));
};

function updatePrices(innerHTML) {
  const currency = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: Shopify.currency.active,
  });

  const priceView = window.localStorage.getItem('price_view');
  const HTML = innerHTML || document;

  if (!priceView) {
    document.body.classList.add('no-tax');
  }

  // return innerHTML;
  if (!priceView) return HTML;
  if (window.country_is_taxable) {
    const prices = HTML?.querySelectorAll('[data-price-brutto]');
    if (prices)
      for (let i = 0; i < prices.length; i++) {
        const el = prices[i];
        const brutto = el.dataset.priceBrutto;
        const netto = el.dataset.priceNetto;

        if (priceView === 'brutto') el.innerHTML = brutto;
        else el.innerHTML = netto;

        el.classList.add('show');
      }

    const mwstInfo = HTML?.querySelectorAll('[data-exkl-mwst]');
    if (mwstInfo)
      for (let i = 0; i < mwstInfo.length; i++) {
        const el = mwstInfo[i];
        const inklMwst = el.dataset.inklMwst;
        const exklMwst = el.dataset.exklMwst;
        if (priceView === 'brutto') el.innerHTML = inklMwst;
        else el.innerHTML = exklMwst;

        el.classList.add('show');
      }
  }
  const navButtons = HTML?.querySelectorAll('.nav-brutto-netto');
  if (navButtons)
    for (let i = 0; i < navButtons.length; i++) {
      const btn = navButtons[i];
      if (priceView === btn.dataset.value) btn.classList.add('active');
      else btn.classList.remove('active');
    }

  if (priceView === 'brutto') {
    document.body.classList.remove('prices_netto');
    document.body.classList.add('prices_brutto');
  } else {
    document.body.classList.remove('prices_brutto');
    document.body.classList.add('prices_netto');
  }

  // set Cart attribute if page is newly loaded
  const cartUpdated = window.sessionStorage.getItem('cart_updated');
  if (!cartUpdated) {
    setCustomerCartAttribute();
    window.sessionStorage.setItem('cart_updated', Date.now());
  }

  if (innerHTML) return HTML;
}

if (window.localStorage.getItem('price_view') === 'brutto') {
  document.body.classList.add('prices_brutto');
} else {
  document.body.classList.add('prices_netto');
}

document.addEventListener('DOMContentLoaded', async function () {
  const navButtons = document.querySelectorAll('.nav-brutto-netto');
  const btnCompany = document.querySelector('.button-company');
  const btnConsumer = document.querySelector('.button-consumer');
  let clickDelay = false;

  const setPriceView = async (value) => {
    if (clickDelay || window.localStorage.getItem('price_view') === value) return;

    window.localStorage.setItem('price_view', value);

    await updatePrices();
    setCustomerCartAttribute(value);

    clickDelay = true;
    setTimeout(() => {
      clickDelay = false;
    }, 1000);
  };

  for (let i = 0; i < navButtons.length; i++) {
    const btn = navButtons[i];
    btn.addEventListener('click', (e) => {
      setPriceView(e.target.dataset.value);
    });
  }

  btnCompany.addEventListener('click', () => setPriceView('netto'));
  btnConsumer.addEventListener('click', () => setPriceView('brutto'));

  // document.addEventListener('set customer cart attribute', async () => {
  //   const priceView = window.localStorage.getItem('price_view');
  //   console.log('setting customer attribute');
  //   await updateCart({
  //     attributes: {
  //       Kunde: priceView === 'netto' ? 'Geschäftskunde' : 'Privatkunde',
  //     },
  //   });
  // });

  await updatePrices();
});
